import useAuth from "app/hooks/useAuth";
import { Navigate, useLocation } from "react-router-dom";

const Redirect = () => {
  const { user } = useAuth(); // get logged in user details
  let location = useLocation();
  // Get redirect location or provide fallback
  // const from = location.state?.from || "/dashboard";
  const from = user !== null && user.resource_access['react-app'].roles[0] === 'student' ? "/student/dashboard" : "/dashboard";

  // in auth callback logic, once authenticated navigate (redirect) back
  // to the route originally being accessed.
  return <Navigate to={from} />;
};

export default Redirect;
